import { ReactElement } from 'react';
import { TextArea as TextAreaComponent } from '@ebsco-ui/ebsco-ui';

import { PropsWithClassName } from '@app/constants';

import { FieldWrapper } from './FieldWrapper';
import { FieldProps } from './constants';

export const TextAreaField = (
  props: PropsWithClassName<FieldProps>
): ReactElement => <FieldWrapper component={TextAreaComponent} {...props} />;
